(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8403],{

/***/ 5166:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thread/10-github-repositories-javascript",
      function () {
        return __webpack_require__(6059);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "meta": function() { return /* binding */ meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1151);
/* harmony import */ var _layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1075);
/* harmony import */ var _components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6833);
/*@jsxRuntime automatic @jsxImportSource react*/ 



const meta = {
    url: "https://devsforgood.com/thread/10-github-repositories-javascript",
    title: "10 GitHub repositories - Javascript",
    description: "10 GitHub repositories that will take your Javascript knowledge to the next level (I bet).\n\nThread \uD83E\uDDF5\uD83D\uDC47",
    image: "/covers/threads/10-github-repositories-javascript.png",
    author: "Csaba Kissi"
};
const MDXLayout = (param)=>{
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__/* .TwitterThreadLayout */ .T, {
        meta: meta,
        children: children
    });
};
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        a: "a"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_3__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadAuthor */ .vI, {
                name: "Csaba Kissi",
                username: "csaba_kissi",
                avatarUrl: "/avatars/csaba_kissi.png"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadOriginalUrl */ .KN, {
                url: "https://twitter.com/csaba_kissi/status/1589976769888542720"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlockFirst */ .Iq, {
                image: "/images/10-github-repositories-javascript-0.png",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "10 GitHub repositories that will take your Javascript knowledge to the next level (I bet)."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Thread \uD83E\uDDF5\uD83D\uDC47"
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            1,
                            " JavaScript Style Guide by Airbnb"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "JavaScript Style Guide."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/airbnb/javascript",
                                children: "https://github.com/airbnb/javascript"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            2,
                            " You-Dont-Know-JS"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "A book series on JavaScript"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/getify/you-dont-know-js",
                                children: "https://github.com/getify/you-dont-know-js"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            3,
                            " 30-Days-Of-JavaScript"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "30 days of JavaScript programming challenge is a step-by-step guide to learning JavaScript programming language in 30 days."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/asabeneh/30-days-of-javascript",
                                children: "https://github.com/asabeneh/30-days-of-javascript"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            4,
                            " Clean-code-javascript"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Clean Code concepts adapted for JavaScript"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/ryanmcdermott/clean-code-javascript",
                                children: "https://github.com/ryanmcdermott/clean-code-javascript"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            5,
                            " 33-js-concepts"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "\uD83D\uDCDC 33 JavaScript concepts every developer should know."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/leonardomso/33-js-concepts",
                                children: "https://github.com/leonardomso/33-js-concepts"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            6,
                            " awesome-javascript"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "\uD83D\uDC22 A collection of excellent browser-side JavaScript libraries, resources, and shiny things."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/sorrycc/awesome-javascript",
                                children: "https://github.com/sorrycc/awesome-javascript"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            7,
                            " Javascript-questions"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "A long list of (advanced) JavaScript questions, and their explanations."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/lydiahallie/javascript-questions",
                                children: "https://github.com/lydiahallie/javascript-questions"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            8,
                            " Javascript-algorithms"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "\uD83D\uDCDD Algorithms and data structures implemented in JavaScript with explanations and links to further readings."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/trekhleb/javascript-algorithms",
                                children: "https://github.com/trekhleb/javascript-algorithms"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            9,
                            " 30-seconds-of-code"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Short JavaScript code snippets for all your development needs."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/30-seconds/30-seconds-of-code",
                                children: "https://github.com/30-seconds/30-seconds-of-code"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            10,
                            " Awesome-JavaScript-Projects"
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "This Repository contains awesome vanilla JavaScript projects."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                        children: [
                            "\uD83D\uDD17 ",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.a, {
                                href: "https://github.com/vishal-raj-1/awesome-javascript-projects",
                                children: "https://github.com/vishal-raj-1/awesome-javascript-projects"
                            })
                        ]
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "You can bookmark this tweet by replying with @SaveToBookmarks #javascript #github"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "You can even unroll the full thread by replying with @SaveToBookmarks unroll"
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "If you want to receive a summary of my best resources you can even subscribe to my weekly newsletter:\ncsabakissi.com/nl"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "That's all, guys."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "If you found this list useful, consider:"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "✅ Follow @csaba_kissi for more content like this"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "\uD83D\uDD14 Enable notifications \uD83D\uDC40"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "\uD83D\uDD04 Retweeting the first tweet."
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Thanks for your support guys! \uD83D\uDE4F\uD83E\uDD1D"
                    })
                ]
            })
        ]
    });
}
function MDXContent() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4500,5675,2361,8411,9774,2888,179], function() { return __webpack_exec__(5166); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);